var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    fillRule: "evenodd",
    d: "M2 8c0-.368.298-.667.667-.667h6.666a.667.667 0 0 1 0 1.334H2.667A.667.667 0 0 1 2 8M2 4c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 4M2 12c0-.368.298-.667.667-.667h2.666a.667.667 0 0 1 0 1.334H2.667A.667.667 0 0 1 2 12",
    clipRule: "evenodd"
  })));
};
export default SvgSort;